/**
 * Neutral identities for producer-declared registered read dependencies.
 * Owning modules may adopt these values when their source lane is available;
 * consumers must never import another decision module to invoke its tool.
 */
export const WORKFORCE_SEAT_CAPABILITY_EXPOSURE_REGISTERED_TARGET = Object.freeze({
  intentId: 'workforce_reduction_seat_capability_exposure',
  toolName: 'workforce_reduction.read_seat_capability_exposure',
});

/** Neutral consumer identity for references discovered by independent modules. */
export const MA_DEAL_THESIS_EXPOSURE_REGISTERED_TARGET = Object.freeze({
  intentId: 'ma_deal_read_thesis_exposure',
  toolName: 'ma-deal.read_thesis_exposure',
});

export const WORKFORCE_SEAT_CAPABILITY_EXPOSURE_METRIC_KEYS = Object.freeze([
  'assignedCount',
  'touchedCount',
  'removedCount',
  'remainingCount',
] as const);

export const WORKFORCE_SEAT_CAPABILITY_EXPOSURE_ANSWER_ANCHORS = Object.freeze({
  metricKeys: [...WORKFORCE_SEAT_CAPABILITY_EXPOSURE_METRIC_KEYS],
  lexemes: [...WORKFORCE_SEAT_CAPABILITY_EXPOSURE_METRIC_KEYS],
  shape: 'decomposition' as const,
});
